import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// =====================================================
// 🚨 MAINTENANCE DÉSACTIVÉE
// =====================================================
const SECRET = 'GOLEM13';

function shouldShowMaintenance() {
  // MAINTENANCE DÉSACTIVÉE
  return false;
}

function showMaintenancePage() {
  document.body.innerHTML = `
    <div style="
      min-height: 100vh;
      background: linear-gradient(180deg, #0c1929 0%, #1a2f4a 100%);
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: system-ui, sans-serif;
      margin: 0;
    ">
      <div style="text-align: center; color: white; padding: 20px;">
        <div style="
          width: 100px;
          height: 100px;
          margin: 0 auto 30px;
          background: #06b6d4;
          border-radius: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 50px;
          box-shadow: 0 0 40px rgba(6,182,212,0.4);
        ">🛒</div>
        <h1 style="font-size: 2.5rem; margin-bottom: 15px; color: #06b6d4;">La Petite Épicerie</h1>
        <p style="font-size: 1.5rem; margin-bottom: 10px; opacity: 0.9;">✨ Maintenance en cours... ✨</p>
        <p style="opacity: 0.7;">Nous revenons très vite !</p>
      </div>
    </div>
  `;
  document.body.style.margin = '0';
}

// =====================================================
// CHECK MAINTENANCE AVANT REACT
// =====================================================
if (shouldShowMaintenance()) {
  showMaintenancePage();
} else {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}
